console.log('commonData.getAppid()'+commonData.getAppid())
const user = {
  state: {
    isSNS: false,
    appid: commonData.getAppid(), //
    name: '',
    catch_components: []
  },
  mutations: {
    GET_CATCHE_COMPONENTS (state, data) {
      state.catch_components = data
    }
   
  },
  actions: {
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js